import script from "./MyFlipContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyFlipContainer.vue?vue&type=script&lang=ts&setup=true"

import "./MyFlipContainer.vue?vue&type=style&index=0&id=15275e8e&lang=scss"

const __exports__ = script;

export default __exports__